import { Inject } from '@odinjs/odin';

import { generateReport, Report } from '@philips-emr/hpms-provider-commons';
import { HpmsReportListAPI } from '@philips-emr/hpms-provider-components';
import Controller, { OnClick, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import { HpmsReportsModalAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.HPMS_REPORTS_MODAL })
class HpmsReportsModalController extends BaseController {

  @Inject(Aliases.HPMS_REPORT_LIST)
  private repList: HpmsReportListAPI;

  @OnMount(Aliases.LAYOUT_MODAL)
  onMount(): void {
    const reports = this.context.get('reports') as Report[];

    this.repList.setData(reports);
  }

  @OnClose(Aliases.LAYOUT_MODAL)
  onclose(): void {
    this.context.set({ cdGroup: undefined, reports: undefined });
    this.historyService.back();
  }

  @OnClick(Aliases.HPMS_REPORT_LIST)
  onRepClick(e: ClickEvent): void {

    const { endpoint, requestParams, reportParams } = this.context.getBulkData();

    const relat = e.value as Report;

    generateReport(endpoint as string, requestParams as {}, relat.cdGrupo, relat, reportParams as {})
      .then(() => this.changeCursor(true)).finally(() => {
        this.changeCursor(false);
        ModalService.close('modal-report-list');
      });
  }

  private changeCursor(isProgress: boolean): void {
    document.body.style.cursor = isProgress ? 'wait' : 'default';
  }

}
export default HpmsReportsModalController;
